<template>
  <section class="">
    <template v-if="!hasPromoCodeApplied">
      <button
        @click="ui.form = true"
        id="apply-promo-code"
        class="mr-auto font-semibold uppercase text-sm px-4 py-1.5 border border-solid border-button-guest-primary rounded font-button text-button-guest-primary"
        :class="ui.form ? 'hidden' : 'block'"
      >
        Apply Promo Code
      </button>

      <div class="flex items-end justify-start gap-2" :class="ui.form ? 'block' : 'hidden'">
        <TextInputGuest label="Promo Code" v-model="promoCode" />
        <ButtonDefault
          @click="onApply"
          class="mr-auto h-12 font-semibold uppercase text-sm px-4 py-1.5 border border-solid border-button-guest-primary rounded font-button text-button-guest-primary disabled:bg-disabled disabled:cursor-not-allowed disabled:border-disabled disabled:text-white"
          :label="ui.isVerifying ? 'Verifying...' : 'Apply'"
          :disabled="ui.isVerifying"
          guest
        />
      </div>
      <ErrorDisplay class="mt-2" v-bind="ui.error" />
    </template>
  </section>
</template>
<script lang="ts">
import { mapState, mapStores } from 'pinia'
import { defineComponent } from 'vue'

import ButtonDefault from '@/common/components/atoms/ButtonDefault.vue'
import ErrorDisplay from '@/common/components/atoms/ErrorDisplay.vue'
import TextInputGuest from '@/common/components/molecules/TextInputGuest.vue'
import { useCheckoutStore } from '@/stores/checkout'
import { blankError, clearError, displayHandled } from '@/utils/errors'

export default defineComponent({
  name: 'PromoBox',
  components: {
    ButtonDefault,
    ErrorDisplay,
    TextInputGuest,
  },
  data() {
    return {
      promoCode: '' as string,
      ui: {
        error: blankError(),
        form: false,
        isVerifying: false,
      },
    }
  },
  computed: {
    ...mapStores(useCheckoutStore),
    ...mapState(useCheckoutStore, ['hasPromoCodeApplied']),
  },
  methods: {
    async onApply() {
      if (this.ui.isVerifying) return

      clearError(this.ui.error)
      if (!this.promoCode) return
      this.ui.isVerifying = true
      try {
        const promotion = await this.checkoutStore.validatePromotionCode(this.promoCode)
        await this.checkoutStore.setPromoCode(promotion)
      } catch (err) {
        displayHandled(err, this.ui.error)
      } finally {
        this.ui.isVerifying = false
      }
    },
  },
})
</script>
